import React from "react";
import { Offcanvas, Badge, Table, Button } from "react-bootstrap";
import { FaDownload, FaPrint, FaFileAlt } from "react-icons/fa";

const ReportViewer = ({ Show, Hide, Title, reportData, onExport, onPrint }) => {
  const report = reportData?.report || {
    name: "Enrollment Report",
    description: "Screened, randomized and status by site",
    category: "Subject",
  };

  const data = reportData?.data || [];
  const generated = reportData?.generated || new Date().toLocaleString();

  const columns = data.length > 0 ? Object.keys(data[0]) : [];

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" size="xl" style={{width: 900}}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title || "Report Viewer"}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {/* Report Header */}
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h5 className="mb-1">{report.name}</h5>
            <div className="text-muted small">{report.description}</div>
            <div className="text-muted small mt-1">
              <span>Generated: {generated}</span>
              <span className="mx-2">·</span>
              <span>{data.length} rows</span>
              <span className="mx-2">·</span>
              <Badge className={`bg-${report.category === "Subject" ? "primary" : 
                report.category === "Inventory" ? "success" : 
                report.category === "Supply Chain" ? "warning" : 
                report.category === "Safety" ? "danger" : "info"}`}>
                {report.category}
              </Badge>
            </div>
          </div>
          <div className="hstack gap-2">
            <button className="updateProfile" onClick={onPrint}>
              <FaPrint className="me-1" size={12} />
              Print
            </button>
            <button className="updateProfile" onClick={onExport}>
              <FaDownload className="me-1" size={12} />
              Export
            </button>
          </div>
        </div>

        <hr className="my-3" />

        {/* Report Data Table */}
        {data.length > 0 ? (
          <div className="table-responsive">
            <Table className="m-0 custom-table" hover>
                <thead className="position-sticky top-0 z-1">
                <tr>
                  {columns.map((col, i) => (
                    <th key={i} className="text-uppercase small">{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((row, i) => (
                  <tr key={i}>
                    {columns.map((col, j) => (
                      <td key={j}>{row[col]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <div className="text-center text-muted py-5">
            <FaFileAlt size={48} className="mb-3 opacity-25" />
            <div>No data available for this report</div>
          </div>
        )}
      </Offcanvas.Body>

      <div className="p-2 bg-light border-top d-flex justify-content-between align-items-center">
        <span className="text-muted small">
          {data.length} rows · Generated {generated}
        </span>
        <button className="updateProfile" onClick={Hide}>
          Close
        </button>
      </div>
    </Offcanvas>
  );
};

export default ReportViewer;